import CampaignManagement from './CampaignManagement'

export default CampaignManagement
